export default __webpack_public_path__ + "static/media/4.cbbd0bd0.jpg";